import "./touchControls.css";
import { createOrientationGate } from "./orientation.js";
import { isMobileHandheld } from "./detect.js";

/**
 * Inicializa capa móvil global: meta táctil, overlay portrait, intento de
 * bloqueo landscape tras el primer gesto del usuario.
 */
export function initMobileShell(): { dispose(): void; tryLockLandscape(): Promise<void> } {
  document.documentElement.classList.add("golazo-mobile-ready");
  if (isMobileHandheld()) {
    document.documentElement.classList.add("golazo-handheld");
  }

  // Evita scroll/zoom accidental durante partido.
  document.body.style.overscrollBehavior = "none";

  const orientation = createOrientationGate(document.body);

  const lockOnGesture = (): void => {
    void orientation.tryLock();
  };
  window.addEventListener("pointerdown", lockOnGesture, { passive: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") void orientation.tryLock();
  });

  return {
    tryLockLandscape: () => orientation.tryLock(),
    dispose: () => {
      window.removeEventListener("pointerdown", lockOnGesture);
      orientation.dispose();
    },
  };
}
